export const TRANSLATION_QUERY = `
query TranslationQuery {
  translationByKey {
      data {
          id
          key
          text
      }
      messages
  }
}`;
